var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.789 11.7617C18.5419 11.7617 16.5338 12.9264 16.5338 15.0783C16.5338 17.5462 20.0952 17.7166 20.0952 18.9564C20.0952 19.4784 19.497 19.9457 18.4753 19.9457C17.0252 19.9457 15.9414 19.2927 15.9414 19.2927L15.4777 21.4642C15.4777 21.4642 16.7262 22.0158 18.3838 22.0158C20.8406 22.0158 22.7738 20.7939 22.7738 18.6052C22.7738 15.9975 19.1975 15.8321 19.1975 14.6814C19.1975 14.2725 19.6886 13.8244 20.7074 13.8244C21.8569 13.8244 22.7948 14.2993 22.7948 14.2993L23.2486 12.202C23.2486 12.202 22.2281 11.7617 20.789 11.7617ZM0.230193 11.92L0.175781 12.2366C0.175781 12.2366 1.12114 12.4096 1.97259 12.7547C3.0689 13.1505 3.147 13.3809 3.33163 14.0965L5.34361 21.8525H8.04068L12.1957 11.92H9.50484L6.83498 18.6732L5.74551 12.9489C5.6456 12.2937 5.13951 11.92 4.52003 11.92H0.230193ZM13.2778 11.92L11.1669 21.8525H13.7328L15.8363 11.92H13.2778ZM27.5892 11.92C26.9704 11.92 26.6426 12.2513 26.402 12.8302L22.6427 21.8525H25.3336L25.8542 20.3488H29.1325L29.449 21.8525H31.8233L29.752 11.92H27.5892ZM27.9391 14.6035L28.7367 18.3306H26.5999L27.9391 14.6035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogoDark);
export default __webpack_public_path__ + "static/media/VisaLogoDark.8c21dcb6a27befe5ae6a9616b1d474c5.svg";
export { ForwardRef as ReactComponent };